<template>
  <DefaultLayout>
    <div class="dotcanvas-wrap">


<!-- 🔹 상단 회색 클릭 영역 -->
<div class="header-card">

  <div class="header-inner">

    <span class="back-icon"
     @click="goBack" role="button"
     tabindex="0" @keyup.enter.prevent="goBack" aria-label="Go back to main page"
    >‹</span>

    <!-- 제목 + 설명을 한 줄로 -->
    <div class="title-row">
      <h1>Cloud Files</h1>
      <p>
        Navigate to a page to review and analyze original images.
      </p>
    </div>

  </div>

</div>

<div class="header-divider"></div>


      <!-- 🔹 하단 구분선 -->
      <div class="header-divider"></div>

      <!-- 🔹 메인 영역 -->
      <div class="content-layout" id="main-content">

        <!-- 왼쪽 카드 -->
        <div class="card">
          <h2>Go to Page</h2>
          <p class="desc">
            Select a page, display on Dot Pad
          </p>

          <div class="page-list" v-if="pages.length">
            <button
              v-for="(p, i) in pages"
              :key="i"
              class="page-pill"
              :class="{ active: currentPage === p }"
              @click.stop="showPageData(p)"
            >
              Page {{ extractNumber(p) }}
            </button>
          </div>
        </div>

        <!-- 오른쪽 카드 -->
        <div class="card">
          <h2>Image Analysis</h2>
          <p class="desc">
            Original Image View & Analysis
          </p>

          <button
            class="analyze-btn"
            @click="goToImageDetail"
            :disabled="!imageUrl"
          >
            Start Image Analysis
          </button>

          <div class="image-box">
            <img v-if="imageUrl" :src="imageUrl" />
          </div>

          <p class="caption">
            Page Preview
          </p>
        </div>

      </div>
    </div>
  </DefaultLayout>
</template>


<script>
import axios from "axios";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { DotpadList } from "@/js/dot/DotpadList.js";
import { dotpadState, dotpadTTS } from "@/js/dot/Dotpad.js";
import { connectChatWS, onChatWS, sendChatJSON, isChatOpen } from "@/socket/socket.js";
import ApiService from '@/services/ApiService';
import {
  speakText,
  stopSpeaking,
  skipSentence,
  replayPrevious,
  togglePlayPause,
} from "@/js/VLM.js";

export default {
  name: "dotCanvas",
  components: {
    DefaultLayout,
  },

  data() {
    return {
      imageUrl: "",
      fileKey: "",
      pages: [],
      loading: false,
      error: "",
      dtmData: "",
      currentPlain: "",
      currentPage: null,
      rate: 1,
      currentDotpadState: "1",
      currentDotpadTTS: "",
      filePath: "",

    };
  },

 async mounted() {
  this.fileKey = this.$route.query.fileKey;  // 🔥 이 줄이 반드시 있어야 함
  this.filePath = this.$route.query.path;
console.log("받은 fileKey:", this.$route.query.fileKey)
  if (!this.fileKey) {
    this.error = "fileKey가 전달되지 않았습니다.";
    return;
  }

  this.fetchFile();
}
,

  beforeUnmount() {
    window.removeEventListener("dotpad-state-changed", this.onDotpadStateChanged);
    window.removeEventListener("dotpad-TTS-changed", this.onDotpadTTSChanged);
    window.removeEventListener("DotPadTTS", this.onDotpadTTSChanged);

    stopSpeaking();
  },

  methods: {
    cleanupAudioTTS() {
      try {
        if (this._fadeRAF) cancelAnimationFrame(this._fadeRAF);
        this._fadeRAF = null;
        this._fadeToken++;

        if (this.thinkingAudio) {
          this.thinkingAudio.pause();
          this.thinkingAudio.currentTime = 0;
          this.thinkingAudio.volume = 0;
        }
        if (this.doneAudio) {
          this.doneAudio.pause();
          this.doneAudio.currentTime = 0;
        }
        stopSpeaking();
      } catch {}
    },
    goBack() {
      this.cleanupAudioTTS();
      this.$router.back();

    },
    async goToImageDetail() {
      if (!this.imageUrl) {
        console.error("이미지 URL 없음!");
        return;
      }

      const base64 = await ApiService.url_image_base64(this.currentPage.imageAttachNo);
      const tempId = "dotcanvas-image";

      this.$router.push({
        name: "ImageDetail",
        params: { id: tempId },
        query: {
          file: base64,
          name: "dtms_image",
          size: null,
          isUploaded: true,
          isAnalyzed: false,
          ours_or_baseline: "1",
          analyzed: JSON.stringify({ from: "dotCanvas" }),
        },
      });

      console.log("➡️ Base64 이미지 분석 페이지로 이동 완료!");
    },

    async testAnalyzeImage() {
      try {
        const sampleImage =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA..."; // 테스트용 base64 이미지

        const result = await ApiService.analyzeImage(sampleImage, "ours");
        console.log("📌 이미지 분석 결과:", result);
      } catch (err) {
        console.error("❌ 테스트 실패:", err);
      }
    },

async fetchFile() {
  try {
    this.loading = true;
    this.error = "";

    const result = await ApiService.loadFile(this.fileKey);
    this.pages = result.pages || [];

    console.log("📄 result.pages:", this.pages);

    // ✅ 첫 페이지 자동 선택
    if (this.pages.length > 0) {
      this.currentPage = this.pages[0];
      await this.showPageData(this.pages[0]);
    }

  } catch (err) {
    this.error = "파일을 불러오는 데 실패했습니다.";
    console.error(err);
  } finally {
    this.loading = false;
  }
}
,

    extractNumber(p) {
      const m = p.name?.match(/\d+/);
      return m ? m[0] : p.page;
    },

    async showPageData(pageItem) {
      if (!pageItem || !pageItem.data) {
        console.error("❌ pageItem 또는 data 없음:", pageItem);
        return;
      }

      this.currentPage = pageItem;

      console.log(`---- 선택한 Page ${this.extractNumber(pageItem)} ----`);
      console.log("HEX:", pageItem.data);
      console.log("📝 plain:", pageItem.plain);
      console.log("📎 imageAttachNo:", pageItem.imageAttachNo);

      this.currentPlain = pageItem.plain;
      speakText(this.currentPlain, this.rate);

      this.dtmData = pageItem.data;
      this.sendToDotPad(this.dtmData);

      // 🔥 여기만 수정
      if (pageItem.imageAttachNo) {
        try {
          // 토큰 포함해서 API로 이미지 받아오기 → base64
          const base64 = await ApiService.url_image_base64(pageItem.imageAttachNo);
          this.imageUrl = base64; // data:image/png;base64,... 형태
          console.log("🖼 미리보기용 base64 길이:", base64?.length);
        } catch (e) {
          console.error("❌ 이미지 미리보기 로드 실패:", e);
          this.imageUrl = "";
        }
      } else {
        this.imageUrl = "";
      }
    },


    onDotpadStateChanged(e) {
      const state = e?.detail?.state || dotpadState;
      console.log("📟 DotPad 상태 변경:", state);

      if (!this.currentPage) return;

      const idx = this.pages.indexOf(this.currentPage);
      if (idx === -1) return;

      if (state === "next") {
        if (idx < this.pages.length - 1) {
          this.showPageData(this.pages[idx + 1]);
        }
      }

      if (state === "prev") {
        if (idx > 0) {
          this.showPageData(this.pages[idx - 1]);
        }
      }
    },

    onDotpadTTSChanged(e) {
      this.currentDotpadTTS = (e?.detail?.tts) || dotpadTTS;
      console.log("🎛 DotPad TTS 입력:", this.currentDotpadTTS);

      switch (this.currentDotpadTTS) {
        case "R":
          skipSentence(this.rate);
          break;
        case "L":
          replayPrevious(this.rate);
          break;
        case "S":
          togglePlayPause(this.rate);
          break;
        default:
          break;
      }
    },

    sendToDotPad(hexData) {
      console.log("📤 DotPad 전송 시작");

      const dotpads = DotpadList.getList();
      if (!dotpads.length) {
        console.error("❌ DotPad 연결 안 됨");
        return;
      }

      for (const pad of dotpads) {
        try {
          pad.dotpadSDK.writeString = hexData;
          pad.dotpadSDK.stringwithPadding = hexData;

          console.log("📨 전송 HEX:", hexData.slice(0, 60) + "...");

          pad.dotpadSDK.sendPixelPattern();

          console.log("✅ DotPad 전송 성공");
        } catch (err) {
          console.error("❌ DotPad 전송 오류:", err);
        }
      }
    },
  },
};
</script>

<style scoped>

.dotcanvas-wrap {
  width: 100%;
  min-height: 100vh;
  background: #f3f4f6;
  padding-bottom: 60px;
  font-family: Pretendard, system-ui, sans-serif;
}

/* 🔹 상단 회색 카드 */
.header-card {
  width: 100%;
  background: #F7F7F7;
  padding: 32px 6%;
  cursor: pointer;
  transition: background 0.2s ease;
}

.header-card:hover {
  background: #dfe3e8;
}

/* 🔹 상단 영역 */
.header-inner {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 20px;
}

/* 제목 + 설명 같은 줄 */
.title-row {
  display: flex;
  align-items: baseline;
  gap: 24px;
  flex-wrap: wrap;
}

.title-row h1 {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
}

.title-row p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}
.back-icon {
  font-size: 22px;
  color: #6b7280;
  margin-top: 6px;
}

.title-area h1 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #111827;
}

.title-area p {
  font-size: 14px;
  color: #6b7280;
}

/* 🔹 하단 흰색 구분선 */
.header-divider {
  width: 100%;
  height: 6px;
  background: white;
  
}

/* 🔹 메인 영역 90%로 꽉 채우기 */
.content-layout {
  width: 90%;
  margin: 40px auto 0 auto;
  background: #F7F7F7;
  display: grid;
  grid-template-columns: 48% 48%;
  gap: 4%;
}

/* 카드도 내부 여백 균형 */
.card {
  width: 100%;
  background: #ffffff;
  border-radius: 18px;
  padding: 36px;
  border: 1px solid #e5e7eb;
  min-height: 450px;
}

.card h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.desc {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
}

/* 🔹 페이지 버튼 */
.page-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.page-pill {
  padding: 8px 18px;
  border-radius: 20px;
  background: #f1f2f4;
  border: none;
  font-size: 13px;
  color: #E5E7EB;
  cursor: pointer;
  transition: 0.2s ease;
}

.page-pill.active {
  background: #ff5a00;
  color: white;
}

/* 🔹 분석 버튼 */
.analyze-btn {
  width: 100%;
  background: #ff5a00;
  border: none;
  border-radius: 24px;
  padding: 14px;
  color: white;
  font-weight: 600;
  margin-bottom: 20px;
  cursor: pointer;
  transition: 0.2s ease;
}

.analyze-btn:hover {
  background: #e14f00;
}

.analyze-btn:disabled {
  background: #E5E7EB;
  cursor: not-allowed;
  color: #A7A7A7;
}

/* 🔹 이미지 박스 */
.image-box {
  background: #fafafa;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 24px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-box img {
  max-height: 200px;
  max-width: 100%;
}

.caption {
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
  margin-top: 10px;
}

@media (max-width: 900px) {
  .content-layout {
    grid-template-columns: 100%;
    gap: 24px;
  }
}

</style>
